import dayjs from "dayjs";
import { MessageContentType } from "features/user/types";
import { ChatMessageItemContent } from "./ChatMessageItemContent";

const Avatar = (props: { src: string }) => {
  return (
    <div
      className="flex-col-center w-[56px] h-[56px] bg-white rounded-full mx-[16px] mt-[10px]"
      style={{
        filter: "drop-shadow(1px 1px 2px rgba(63, 74, 97, 0.4))",
        transform: "translateZ(0)", // for safari
      }}
    >
      <div className="flex-col-center w-[85%] h-[85%] rounded-full overflow-hidden">
        <img src={props.src} key={props.src} className="w-full h-full object-contain" />
      </div>
    </div>
  );
};

export const ChatMessageItem = (props: {
  isFromUser: boolean;
  name: string;
  icon: string;
  messageContent: any;
  messageContentType: MessageContentType;
  created_at: string;
}) => {
  const { isFromUser, name, icon, messageContent, messageContentType, created_at } = props;

  return (
    <div className="flex-row-view my-4">
      {isFromUser ? (
        <>
          <div className="flex-col-el relative flex-1">
            <div className="flex-row-view justify-end">
              <p className="text text-textcolor-black !text-right">{name}</p>
            </div>

            {messageContentType === MessageContentType.IMAGE_WITH_TEXT ? (
              <>
                {/* 画像行（タイムスタンプなし） */}
                <div className="flex-row-view justify-end">
                  <div className="ml-1">
                    <img src={messageContent.url} className="w-[100px] h-[100px]" />
                  </div>
                </div>
                {/* テキスト行（タイムスタンプあり） */}
                <div className="flex-row-view items-end justify-end mt-1">
                  <p className="text text-textcolor-black">
                    {dayjs(created_at, "YYYY-MM-DDTHH:mm:ssZ").format("HH:mm")}
                  </p>
                  <div className="max-w-[60%] p-3 rounded-md bg-green-80 ml-1">
                    <p className="text text-textcolor-black !text-left break-all !whitespace-pre-line">
                      {messageContent.text}
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex-row-view items-end justify-end">
                <p className="text text-textcolor-black">
                  {dayjs(created_at, "YYYY-MM-DDTHH:mm:ssZ").format("HH:mm")}
                </p>
                <ChatMessageItemContent
                  isFromUser={true}
                  messageContentType={messageContentType}
                  messageContent={messageContent}
                />
              </div>
            )}
          </div>

          <Avatar src={icon} />
        </>
      ) : (
        <>
          <Avatar src={icon} />

          <div className="flex-col-el relative flex-1">
            <div className="flex-row-view">
              <p className="text text-textcolor-black">{name}</p>
            </div>

            {messageContentType === MessageContentType.IMAGE_WITH_TEXT ? (
              <>
                {/* 画像行（タイムスタンプなし） */}
                <div className="flex-row-view">
                  <div className="mr-1">
                    <img src={messageContent.url} className="w-[100px] h-[100px]" />
                  </div>
                </div>
                {/* テキスト行（タイムスタンプあり） */}
                <div className="flex-row-view items-end mt-1">
                  <div className="max-w-[60%] p-3 rounded-md bg-gray-20 mr-1">
                    <p className="text text-textcolor-black !text-left break-all !whitespace-pre-line">
                      {messageContent.text}
                    </p>
                  </div>
                  <p className="text text-textcolor-black">
                    {dayjs(created_at, "YYYY-MM-DDTHH:mm:ssZ").format("HH:mm")}
                  </p>
                </div>
              </>
            ) : (
              <div className="flex-row-view items-end">
                <ChatMessageItemContent
                  isFromUser={false}
                  messageContentType={messageContentType}
                  messageContent={messageContent}
                />

                <p className="text text-textcolor-black">
                  {dayjs(created_at, "YYYY-MM-DDTHH:mm:ssZ").format("HH:mm")}
                </p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
